import React from 'react'; 
import SearchContainer from '../../../../components/SearchContainer';

function PesquisaContrato({formData, handleSearch}) {
  
  return (
    <SearchContainer
      field={formData.contractNumber}
      onSearch={handleSearch} 
    />
  );
}

export default PesquisaContrato;